import { lighten, opacify } from "polished";
import getChartColor from "../../../components/charts/colors";

export const getUseCaseColor = (idx: number) => {
  const chartColor = getChartColor(idx);
  return lighten(0.1, opacify(0.25, chartColor));
};

export const MY_USE_CASE_ID = "__my_usecase__";
